export default options => {
  const { meta, data } = options;
  const { url } = meta;

  if (url.includes('/api/v5/courseware_units/filters')) {
    if (data.catalogues) {
      data.catalogues.unshift({ uuid: 'common', value: '通用资源' });
      data.catalogues = nx.keyMap(data.catalogues, { name: 'value' });
    }
  }

  return options;
};
